import { createApp , reactive} from 'vue';
import App from './App.vue';
import BackendNotFound from './views/ViewTopic/404NotFOund/BackendNotFound.vue';
import router from './router';
import {clear_token, get_token} from './router';
import {
  get_vapid_public_key,
  get_web_push_permission,
  is_web_push_supported,
  subscribe_to_web_push,
  sync_existing_web_push_subscription
} from '@/services/web_push';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
 
import '@/assets/css/new_style.css';
 
import AllCommunityAssets from './components/GetCommunityAssets/CommunityAsset.vue';
import CommunityAssetModal from './components/CommunityAssetModal/CommunityAssetModal.vue';
import FloatingButton from './components/FloatingButton/FloatingButtonComponent.vue';
 
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import {
  connect_organisation_realtime_socket,
  connect_realtime_socket,
  disconnect_portal_realtime_socket,
  disconnect_realtime_socket,
  set_realtime_socket_auth_checker
} from "./services/realtime";
// Set up the global AJAX handler
$(document).ajaxComplete(function(event, xhr) {
    if (xhr.status === 401) {
        clear_token();
        window.location.href = escape("/");
    }
});

// Export a promise that resolves with client domain
export let client_domain = '';

export const client_features = reactive({});

const CLIENT_LOGOS = {
  Chamber: require('@/assets/images/ictchamberlogo.png'),
  Workstreams: require('@/assets/images/workstreams_color_logo.png'),
  vsi: require('@/assets/images/epf_black_logo.png'),
  Engagenet: require('@/assets/images/engagenet_blue_2.png'),
  Sandton: require('@/assets/images/919_logo.png'),
  Community: require('@/assets/images/funaxlogo.png'),
  Legacy: require('@/assets/images/legacy_build.png'),
  Workbook: require('@/assets/images/aic_logo.png'),
  CBO: require('@/assets/images/cbo-logo.svg'),
  TDM: require('@/assets/images/tdm.png'),
  NSP: require('@/assets/images/NSP Logo.png'),
  DWYPD: require('@/assets/images/dwypd_clear_logo.png'),
  BOSA: require('@/assets/images/bosa_black.png'),
  REMAT: require('@/assets/images/EngageNet Remat.png'),
  chiefluthuli: require('@/assets/images/chiefluthuli_image/Luthuli_crest.png'),
  Apex: require('@/assets/images/Apex_solve_logos/apex_logo_variants-03.png'),
  vettedsa:require('@/assets/images/vetted_sa/vettedsa_logo.png'),
  aicreads: require('@/assets/images/engagenet_white.png'),
  aicone: require('@/assets/images/engagenet_white.png'),

};

const SIDE_LOGOS = {
  Chamber: require('@/assets/images/ictchamberlogo.png'),
  Workstreams: require('@/assets/images/workstreams_color_logo.png'),
  vsi: require('@/assets/images/epf_black_logo.png'),
  Engagenet: require('@/assets/images/Engagenet black.png'),
  Sandton: require('@/assets/images/919_logo.png'),
  Community: require('@/assets/images/funaxlogo.png'),
  Legacy: require('@/assets/images/legacy_build.png'),
  Workbook: require('@/assets/images/aic_logo.png'),
  CBO: require('@/assets/images/cbo_logo.png'),
  TDM: require('@/assets/images/tdm.png'),
  NSP: require('@/assets/images/NSP Logo.png'),
  DWYPD: require('@/assets/images/women_logo.jpg'),
  BOSA: require('@/assets/images/bosa_black.png'),
  REMAT: require('@/assets/images/remat_holdings_logo.png'),
  chiefluthuli: require('@/assets/images/chiefluthuli_image/Luthuli.svg'),
  Apex: require('@/assets/images/Apex_solve_logos/apex_logo_variants-03.png'),
  vettedsa:require('@/assets/images/vetted_sa/Vetted_sa_main_logo.png'),
  aicreads: require('@/assets/images/Engagenet black.png'),
  aicone: require('@/assets/images/Engagenet black.png'),




};

const CLIENT_BACKGROUNDS = {
  Workstreams: require('@/assets/images/workstream_background.png'),
  vsi: require('@/assets/images/epf_black_logo.png'),
  Sandton: require('@/assets/images/new_background.png'),
  Chamber: require('@/assets/images/chamber_background.png'),
  Community: require('@/assets/images/funaxbackground.png'),
  Legacy: require('@/assets/images/legacy_background.png'),
  Workbook: require('@/assets/images/aic_background.png'),
  CBO: require('@/assets/images/cbo_background.png'),
  TDM: require('@/assets/images/tdm_background.png'),
  NSP: require('@/assets/images/soulcity_bg.png'),
  DWYPD: require('@/assets/images/dwypd_bg.png'),
  BOSA: require('@/assets/images/bosa_bg.png'),
  REMAT: require('@/assets/images/new-bg.png'),
  chiefluthuli: require('@/assets/images/chiefluthuli_image/Luthuli.svg'),
  vettedsa:require('@/assets/images/vetted_sa/Vetted_sa_main_logo.png'),
  aicreads: require('@/assets/images/aic_background.png'),
  aicone: require('@/assets/images/aic_background.png'),



};

const AICONE_LOGO = {
  Engagenet: require('@/assets/images/aicone_logo_v3.svg'),
  Apex: require('@/assets/images/apex_solve_aicone/solve.svg'),

};

const PROBA_WORKFLOWS_LOGO = {
  Engagenet: require('@/assets/images/platform_icons/proba.svg')


};

const PROBA_ANALYTICS_LOGO = {
  Engagenet: require('@/assets/images/platform_icons/proba.svg'),
  Apex: require('@/assets/images/apex_solve_aicone/data.svg'),


};

const ENGAGENET_LOGO = {
  Engagenet: require('@/assets/images/platform_icons/engagenet.svg'),
  Apex: require('@/assets/images/apex_solve_aicone/engage.svg'),


};


const XVERDICT_LOGO = {
  Engagenet: require('@/assets/images/platform_icons/xverdict.svg')

};

const ORCAA_LOGO = {
  Engagenet: require('@/assets/images/platform_icons/orcaa.svg'),


};

const COMPLYON_LOGO = {
  Engagenet: require('@/assets/images/platform_icons/complyon.svg'),
  Apex: require('@/assets/images/apex_solve_aicone/onboarding.svg'),

};

const SECTION_BACKGROUNDS = {
  Workstreams: require('@/assets/images/workstreams_banner.png'),
  Sandton: require('@/assets/images/919_bg.jpg'),
  Chamber: require('@/assets/images/chamber_background.png'),
  Community: require('@/assets/images/funaxback.jpg'),
  Legacy: require('@/assets/images/legacy_background.png'),
  Workbook: require('@/assets/images/ai_banner.jpg'),
  CBO: require('@/assets/images/cbo_banner.jpg'),
  TDM: require('@/assets/images/tdm_background.png'),
  NSP: require('@/assets/images/soulcity_background.jpeg'),
  DWYPD: require('@/assets/images/women_logo.jpg'),
  BOSA: require('@/assets/images/bosa_banner.png'),
  REMAT: require('@/assets/images/about.jpg'),
  chiefluthuli: require('@/assets/images/chiefluthuli_image/Luthuli.svg'),
  vettedsa:require('@/assets/images/vetted_sa/Vetted_sa_main_logo.png'),
  aicreads: require('@/assets/images/ai_banner.jpg')



};

const FAVICON_LOGOS = {
  Chamber: require('../public/images/ict-chamber-logo.png'),
  Workstreams: require('../public/images/probafav.png'),
  vsi: require('../public/images/epf_favicon_logo.png'),
  Engagenet: require('@/assets/images/engagenet_white.png'),
  Sandton: require('../public/images/sandton_digital_favicon.png'),
  Community: require('@/assets/images/funaxlogo.png'),
  Legacy: require('@/assets/images/legacy_build.png'),
  Workbook: require('../public/images/1.svg'),
  CBO: require('@/assets/images/cbo_favicon.png'),
  TDM: require('@/assets/images/tdm.png'),
  NSP: require('@/assets/images/NSP Logo.png'),
  DWYPD: require('@/assets/images/dwypd_clear_logo.png'),
  BOSA: require('@/assets/images/bosa_black.png'),
  REMAT: require('@/assets/images/8.png'),
  chiefluthuli: require('@/assets/images/chiefluthuli_image/Luthuli_crest.png'),
  Apex: require('@/assets/images/Apex_solve_logos/apex_logo_variants-07.png'),
  vettedsa: require('@/assets/images/vetted_sa/Vetted_sa_main_logo.png')
};

function normalizeClientKey(client) {
  const client_name = String(client || '').toLowerCase();
  return Object.keys(CLIENT_LOGOS).find(key => key.toLowerCase() === client_name) || client;
}
 
function getClientLogo(client) {
  return Reflect.get(CLIENT_LOGOS, normalizeClientKey(client))
    || require('@/assets/images/workstreams_color_logo.png');
}
 
function getSideLogo(client) {
  return Reflect.get(SIDE_LOGOS, normalizeClientKey(client))
    || require('@/assets/images/Engagenet black.png');
}
 
function getClientBgImage(client) {
  return Reflect.get(CLIENT_BACKGROUNDS, normalizeClientKey(client));
}
 
function getBackgroundSection(client) {
  return Reflect.get(SECTION_BACKGROUNDS, normalizeClientKey(client))
}

function getFaviconLogo(client) {
  return Reflect.get(FAVICON_LOGOS, normalizeClientKey(client))
    || require('@/assets/images/engagenet_white.png');
}

function getComplyonLogo(client) {
  return Reflect.get(COMPLYON_LOGO, normalizeClientKey(client))
    || require('@/assets/images/engagenet_bg.png');
}

function getOrcaaLogo(client) {
  return Reflect.get(ORCAA_LOGO, normalizeClientKey(client))
    || require('@/assets/images/engagenet_bg.png');
}

function getXverdictLogo(client) {
  return Reflect.get(XVERDICT_LOGO, normalizeClientKey(client));
}

function getProbaanalyticLogo(client) {
  return Reflect.get(PROBA_ANALYTICS_LOGO, normalizeClientKey(client));
}

function getProbaworkflowsLogo(client) {
  return Reflect.get(PROBA_WORKFLOWS_LOGO, normalizeClientKey(client))
}

function getAiconeLogo(client) {
  return Reflect.get(AICONE_LOGO, normalizeClientKey(client));
}

function getEngageLogo(client) {
  return Reflect.get(ENGAGENET_LOGO, normalizeClientKey(client));
}
 
let appMounted = false;
let webPushPromptInProgress = false;
const WEB_PUSH_PROMPT_ID = 'web-push-enable-prompt';

function closeWebPushPrompt() {
  const existingPrompt = document.getElementById(WEB_PUSH_PROMPT_ID);
  if (existingPrompt) existingPrompt.remove();
  webPushPromptInProgress = false;
}

function showWebPushPrompt({ token, userId }) {
  if (document.getElementById(WEB_PUSH_PROMPT_ID)) return;

  const overlay = document.createElement('div');
  overlay.id = WEB_PUSH_PROMPT_ID;
  overlay.className = 'web-push-enable-prompt';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');

  const panel = document.createElement('div');
  panel.className = 'web-push-enable-prompt__panel';

  const title = document.createElement('h3');
  title.textContent = 'Enable notifications?';
  title.className = 'web-push-enable-prompt__title';

  const body = document.createElement('p');
  body.textContent = 'Get important updates even when you are not actively using the app.';
  body.className = 'web-push-enable-prompt__body';

  const errorText = document.createElement('p');
  errorText.className = 'web-push-enable-prompt__error d-none';

  const actions = document.createElement('div');
  actions.className = 'web-push-enable-prompt__actions';

  const notNowButton = document.createElement('button');
  notNowButton.type = 'button';
  notNowButton.textContent = 'Not now';
  notNowButton.className = 'web-push-enable-prompt__button web-push-enable-prompt__button--secondary';

  const enableButton = document.createElement('button');
  enableButton.type = 'button';
  enableButton.textContent = 'Enable';
  enableButton.className = 'web-push-enable-prompt__button web-push-enable-prompt__button--primary';

  notNowButton.addEventListener('click', () => {
    sessionStorage.setItem(`webPushPromptDismissed:${userId}`, 'true');
    closeWebPushPrompt();
  });

  enableButton.addEventListener('click', async () => {
    enableButton.disabled = true;
    enableButton.textContent = 'Enabling...';
    errorText.classList.add('d-none');

    try {
      await subscribe_to_web_push({
        baseUrl: process.env.VUE_APP_BACKEND_API_URL,
        token,
        userId,
        projectId: process.env.VUE_APP_PROJECT_ID
      });
      closeWebPushPrompt();
    } catch (error) {
      errorText.textContent = error.message || 'Could not enable browser notifications.';
      errorText.classList.remove('d-none');
      enableButton.disabled = false;
      enableButton.textContent = 'Enable';
    }
  });

  actions.append(notNowButton, enableButton);
  panel.append(title, body, errorText, actions);
  overlay.appendChild(panel);
  document.body.appendChild(overlay);
}

function promptForWebPushOnAnyRoute() {
  const token = get_token();
  const userId = localStorage.getItem('user_id');

  if (!token || !userId) return;
  if (!is_web_push_supported() || !get_vapid_public_key()) return;
  if (get_web_push_permission() !== 'default') return;
  if (webPushPromptInProgress) return;

  const dismissedKey = `webPushPromptDismissed:${userId}`;
  if (sessionStorage.getItem(dismissedKey) === 'true') return;

  webPushPromptInProgress = true;
  showWebPushPrompt({ token, userId });
}

const updateFavicon = (client) => {
  const favicon = document.querySelector("link[rel='icon']");
  const apple_icon = document.querySelector("link[rel='apple-touch-icon']");
  const logo_path = getFaviconLogo(client);
  // Update standard Favicon
  if (favicon) {
    favicon.href = logo_path;
  }

  // Update Apple Touch Icon (Essential for iPad)
  if (apple_icon) {
    apple_icon.href = logo_path;
  }
};

function update_meta_tags(data, client) {
  const title = data.title || client;
  const description = data.welcome_text || `${client} - Your platform`;

  // Update title
  document.title = title;

  // Update or create meta description
  let metaDesc = document.querySelector('meta[name="description"]');
  if (!metaDesc) {
    metaDesc = document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    document.head.appendChild(metaDesc);
  }
  metaDesc.setAttribute('content', description);

  // Open Graph
  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (!ogTitle) {
    ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    document.head.appendChild(ogTitle);
  }
  ogTitle.setAttribute('content', title);

  let ogDesc = document.querySelector('meta[property="og:description"]');
  if (!ogDesc) {
    ogDesc = document.createElement('meta');
    ogDesc.setAttribute('property', 'og:description');
    document.head.appendChild(ogDesc);
  }
  ogDesc.setAttribute('content', description);

  let ogImage = document.querySelector('meta[property="og:image"]');
  if (!ogImage) {
    ogImage = document.createElement('meta');
    ogImage.setAttribute('property', 'og:image');
    document.head.appendChild(ogImage);
  }
  ogImage.setAttribute('content', getClientLogo(client));
}

function has_realtime_auth() {
  return Boolean(get_token());
}

function sync_realtime_socket_connection() {
  if (has_realtime_auth()) {
    connect_realtime_socket();
    connect_organisation_realtime_socket();
    return;
  }

  disconnect_realtime_socket();
  disconnect_portal_realtime_socket();
}

set_realtime_socket_auth_checker(has_realtime_auth);
window.addEventListener("auth:cleared", sync_realtime_socket_connection);

function mountApp(client = 'Engagenet', data = {}) {
  if (appMounted) return client_domain;

  const client_key = normalizeClientKey(client);
  document.title = data.title || client_key;
  client_domain = client_key.toLowerCase();
  document.documentElement.setAttribute('data-client', client_key);


  if (data.features) {
    Object.assign(client_features, data.features);
  }

  const app = createApp(App);
  sync_realtime_socket_connection();
  app.provide('client_features', client_features);
  app.component('AllCommunityAssets', AllCommunityAssets);
  app.component('CommunityAssetModal', CommunityAssetModal);
  app.component('FloatingButton', FloatingButton);
  app.component('QuillEditor', QuillEditor);

  app.config.globalProperties.$clientLogo = getClientLogo(client_key);
  app.config.globalProperties.$sideLogo = getSideLogo(client_key);
  app.config.globalProperties.$clientBgImage = getClientBgImage(client_key);
  app.config.globalProperties.$backgroundSection = getBackgroundSection(client_key);
  app.config.globalProperties.$welcomeText = data.welcome_text;
  app.config.globalProperties.$title = data.title || client_key;
  app.config.globalProperties.$Complyon = getComplyonLogo(client_key);
  app.config.globalProperties.$Orcaa = getOrcaaLogo(client_key);
  app.config.globalProperties.$Xverdict = getXverdictLogo(client_key);
  app.config.globalProperties.$probaanalytics = getProbaanalyticLogo(client_key);
  app.config.globalProperties.$probaworkflows = getProbaworkflowsLogo(client_key);
  app.config.globalProperties.$aicone = getAiconeLogo(client_key);
  app.config.globalProperties.$Engage = getEngageLogo(client_key);

  updateFavicon(client_key);
  update_meta_tags(data, client_key);

  app.mixin({
      mounted() {
          if (this.$title) document.title = this.$title;
      }
  });

  app.use(router).mount('#app');
  router.afterEach(() => {
    sync_realtime_socket_connection();
    window.setTimeout(promptForWebPushOnAnyRoute, 500);
  });

  document.documentElement.style.setProperty('--client-bg-image', `url(${app.config.globalProperties.$clientBgImage})`);

  if (app.config.globalProperties.$backgroundSection) {
    document.documentElement.style.setProperty('--client-bg-section', `url(${app.config.globalProperties.$backgroundSection})`);
  } else {
    document.documentElement.style.removeProperty('--client-bg-section');
  }
  window.dispatchEvent(new Event('app-mounted'));
  appMounted = true;

  sync_existing_web_push_subscription({
    baseUrl: process.env.VUE_APP_BACKEND_API_URL,
    token: get_token(),
    userId: localStorage.getItem('user_id'),
    projectId: process.env.VUE_APP_PROJECT_ID
  }).catch(error => {
    console.warn('Web push sync skipped.', error);
  });

  window.setTimeout(promptForWebPushOnAnyRoute, 800);

  return client_domain;
}

function NotFound() {
  if (appMounted) return client_domain;

  client_domain = 'engagenet';
  document.title = '404 | Page Not Found';
  document.documentElement.setAttribute('data-client', 'Engagenet');
  updateFavicon('Engagenet');

  createApp(BackendNotFound).mount('#app');
  window.dispatchEvent(new Event('app-mounted'));
  appMounted = true;

  return client_domain;
}

// Load backend config
export const loadAppConfig = async () => {
  try {
      const res = await fetch(`${process.env.VUE_APP_BACKEND_API_URL}/config/`);

      if (!res.ok) {
        throw new Error(`Config request failed with status ${res.status}`);
      }

      const data = await res.json();
      const client = data.client || "Engagenet";
      return mountApp(client, data);
  } catch (err) {
      console.error("Failed to load backend config:", err);
      return NotFound();
  }
};
 
// Immediately load config
loadAppConfig();
